import i18n from 'src/locales/i18n';

// NOTA i18n: TIPOS_IMOVEL/TIPOS_BY_ID/buildInitialWorkflow são consumidos fora
// deste escopo de edição por EscopoSection.js (reduce em module-level) e por
// PerguntasFlowCanvas.jsx (buildInitialWorkflow() chamado fora de render, ex.:
// handler de reset). Transformar isso em hook (useTiposImovel()) quebraria
// esses dois consumidores (module-level reduce não pode chamar hook; chamada
// fora de render viola Rules of Hooks). Por isso a shape exportada (arrays e
// função plana) foi mantida intacta, e a tradução usa a instância `i18n`
// importada diretamente — mesmo padrão já usado em src/layouts/chats/NavConfig.js
// e src/utils/formatTime.js. Only os `label` (texto exibido) passam por
// i18n.t(); os `id` continuam como identificadores internos (comparados em
// EscopoSection.js/PerguntasFlowCanvas.jsx) e não são traduzidos.
export const TIPOS_IMOVEL = [
    { id: 'lote', label: i18n.t('settings:aiAgents.realstate.tiposImovel.lote', 'Lote'), icon: 'mdi:vector-square', destino: 'ambos' },
    { id: 'cobertura', label: i18n.t('settings:aiAgents.realstate.tiposImovel.cobertura', 'Cobertura'), icon: 'mdi:terrain', destino: 'residencial' },
    { id: 'galpao', label: i18n.t('settings:aiAgents.realstate.tiposImovel.galpao', 'Galpão'), icon: 'mdi:warehouse', destino: 'comercial' },
    { id: 'loja-sobreloja', label: i18n.t('settings:aiAgents.realstate.tiposImovel.lojaSobreloja', 'Loja e sobreloja'), icon: 'mdi:storefront-outline', destino: 'comercial' },
    { id: 'sobreloja', label: i18n.t('settings:aiAgents.realstate.tiposImovel.sobreloja', 'Sobreloja'), icon: 'mdi:storefront-outline', destino: 'comercial' },
    { id: 'predio-comercial', label: i18n.t('settings:aiAgents.realstate.tiposImovel.predioComercial', 'Prédio comercial'), icon: 'mdi:office-building-outline', destino: 'comercial' },
    { id: 'barracao', label: i18n.t('settings:aiAgents.realstate.tiposImovel.barracao', 'Barracão'), icon: 'mdi:home-silo-outline', destino: 'comercial' },
    { id: 'apartamento', label: i18n.t('settings:aiAgents.realstate.tiposImovel.apartamento', 'Apartamento'), icon: 'mdi:home-city-outline', destino: 'residencial' },
    { id: 'sala', label: i18n.t('settings:aiAgents.realstate.tiposImovel.sala', 'Sala'), icon: 'mdi:door-open', destino: 'comercial' },
    { id: 'terraco', label: i18n.t('settings:aiAgents.realstate.tiposImovel.terraco', 'Terraço'), icon: 'mdi:balcony', destino: 'ambos' },
    { id: 'apto-comercial', label: i18n.t('settings:aiAgents.realstate.tiposImovel.aptoComercial', 'Apto. Comercial'), icon: 'mdi:office-building-outline', destino: 'comercial' },
    { id: 'loja', label: i18n.t('settings:aiAgents.realstate.tiposImovel.loja', 'Loja'), icon: 'mdi:store-outline', destino: 'comercial' },
    { id: 'andar-corrido', label: i18n.t('settings:aiAgents.realstate.tiposImovel.andarCorrido', 'Andar corrido'), icon: 'mdi:office-building-outline', destino: 'comercial' },
    { id: 'imovel-comercial', label: i18n.t('settings:aiAgents.realstate.tiposImovel.imovelComercial', 'Imóvel comercial'), icon: 'mdi:storefront-outline', destino: 'comercial' },
    { id: 'predio', label: i18n.t('settings:aiAgents.realstate.tiposImovel.predio', 'Prédio'), icon: 'mdi:office-building', destino: 'ambos' },
    { id: 'sobrado', label: i18n.t('settings:aiAgents.realstate.tiposImovel.sobrado', 'Sobrado'), icon: 'mdi:home-modern', destino: 'residencial' },
    { id: 'chacara', label: i18n.t('settings:aiAgents.realstate.tiposImovel.chacara', 'Chácara'), icon: 'mdi:pine-tree', destino: 'residencial' },
    { id: 'estacionamento', label: i18n.t('settings:aiAgents.realstate.tiposImovel.estacionamento', 'Estacionamento'), icon: 'mdi:parking', destino: 'comercial' },
    { id: 'loja-galpao', label: i18n.t('settings:aiAgents.realstate.tiposImovel.lojaGalpao', 'Loja e Galpão'), icon: 'mdi:warehouse', destino: 'comercial' },
    { id: 'casa-comercial', label: i18n.t('settings:aiAgents.realstate.tiposImovel.casaComercial', 'Casa Comercial'), icon: 'mdi:home-city', destino: 'comercial' },
    { id: 'kitnet', label: i18n.t('settings:aiAgents.realstate.tiposImovel.kitnet', 'Kitnet'), icon: 'mdi:bed-single-outline', destino: 'residencial' },
    { id: 'casa', label: i18n.t('settings:aiAgents.realstate.tiposImovel.casa', 'Casa'), icon: 'mdi:home-outline', destino: 'residencial' },
    { id: 'sitio', label: i18n.t('settings:aiAgents.realstate.tiposImovel.sitio', 'Sítio'), icon: 'mdi:barn', destino: 'residencial' },
];

export const TIPOS_BY_ID = TIPOS_IMOVEL.reduce((acc, t) => {
    acc[t.id] = t;
    return acc;
}, {});

export function buildInitialWorkflow() {
    const root = {
        id: 'root',
        type: 'rootNode',
        position: { x: 0, y: 0 },
        data: { label: i18n.t('settings:aiAgents.realstate.tiposImovel.workflowRootLabel', 'Início da coleta'), perguntas: [] },
    };

    const finalidade = {
        id: 'finalidade',
        type: 'finalidadeNode',
        position: { x: 0, y: 150 },
        data: {
            label: i18n.t('settings:aiAgents.realstate.tiposImovel.workflowFinalidadeLabel', 'Venda / Aluguel'),
            icon: 'mdi:swap-horizontal',
            finalidade: 'ambos',
            perguntas: [],
        },
    };

    const destinos = [
        { id: 'comercial', destino: 'comercial', x: -260, tiposIniciais: ['loja', 'sala'] },
        { id: 'residencial', destino: 'residencial', x: 260, tiposIniciais: ['casa', 'apartamento'] },
    ];

    const destinoNodes = destinos.map((d) => ({
        id: d.id,
        type: 'destinoNode',
        position: { x: d.x, y: 310 },
        data: {
            label: d.destino === 'comercial'
                ? i18n.t('settings:aiAgents.realstate.tiposImovel.destinoComercialLabel', 'Comercial')
                : i18n.t('settings:aiAgents.realstate.tiposImovel.destinoResidencialLabel', 'Residencial'),
            icon: d.destino === 'comercial' ? 'mdi:storefront-outline' : 'mdi:home-outline',
            destino: d.destino,
            perguntas: [],
        },
    }));

    const tipoNodes = destinos.flatMap((d) =>
        d.tiposIniciais.map((tipoId, idx) => {
            const tipo = TIPOS_BY_ID[tipoId];
            const offsetX = (idx - (d.tiposIniciais.length - 1) / 2) * 200;
            return {
                id: `${d.id}_${tipoId}`,
                type: 'tipoNode',
                position: { x: d.x + offsetX, y: 470 },
                data: {
                    label: tipo.label,
                    icon: tipo.icon,
                    tipoId,
                    destino: d.destino,
                    perguntas: [],
                },
            };
        })
    );

    const nodes = [root, finalidade, ...destinoNodes, ...tipoNodes];

    const edges = [
        { id: 'e_root_finalidade', source: 'root', target: 'finalidade' },
        ...destinos.map((d) => ({ id: `e_finalidade_${d.id}`, source: 'finalidade', target: d.id })),
        ...destinos.flatMap((d) =>
            d.tiposIniciais.map((tipoId) => ({
                id: `e_${d.id}_${tipoId}`,
                source: d.id,
                target: `${d.id}_${tipoId}`,
            }))
        ),
    ];

    return { nodes, edges };
}
